import React from 'react';
import PropTypes from 'prop-types';
import AllocationRuleEditorLink from '../../../../../../components/filter-editor/allocation-rule-editor-link';
import { noop } from 'ui-components/default-props/noop';
import style from './style.module.less';

const CustomEditor = ({ ruleName, filterId, onRuleNameUpdated, onRuleEditorClosed = noop }) => {
  return (
    <AllocationRuleEditorLink
      allocationRuleName={ruleName}
      className={style['edit-rule-link']}
      filterId={filterId}
      onRuleEditorClosed={onRuleEditorClosed}
      onRuleNameUpdated={onRuleNameUpdated}
      theme='link'
    />
  );
};

CustomEditor.propTypes = {
  ruleName: PropTypes.string.isRequired,
  filterId: PropTypes.number.isRequired,
  onRuleNameUpdated: PropTypes.func.isRequired,
  onRuleEditorClosed: PropTypes.func,
};

export default CustomEditor;
